module.exports = __webpack_public_path__ + "img/teknelerim-empty.ec0e1c33.svg";